import Modal from '@design/objects/modal/twig/assets'
import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'
import * as PanelManager from 'assets/core/js/module/panelManager'
import type { ModalConfig as BaseModalConfig } from '@design/objects/modal/twig/assets'

export type ModalType = Modal
export type ModalConfig = BaseModalConfig

export const Events = {
  MODAL_OPENED: 'modal.opened',
  MODAL_CLOSED: 'modal.closed',
}

export default (element: string | HTMLElement, config?: ModalConfig): Modal => {
  if (!config) {
    config = {}
  }

  let onOpen: ModalConfig['onOpen'] | null = null
  let onClose: ModalConfig['onClose'] | null = null

  if (config?.onOpen) {
    onOpen = config.onOpen
  }

  config.onOpen = (modal) => {
    PanelManager.add(modal)
    onOpen?.(modal)
    modal.getElement().dispatchEvent(new CustomEvent(Events.MODAL_OPENED))
  }

  if (config?.onClose) {
    onClose = config.onClose
  }

  config.onClose = (modal) => {
    PanelManager.remove(modal)
    onClose?.(modal)
    modal.getElement().dispatchEvent(new CustomEvent(Events.MODAL_CLOSED))
  }

  const modal = new Modal(element, config)

  ElementPropertiesManager.addProperty(modal.getElement(), 'modal', modal)

  return modal
}
